module.exports = __webpack_public_path__ + "static/media/friendventure-3.2ac519f2.JPG";